/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';

const viewportContext = React.createContext<{
  height?: number;
  width?: number;
}>({});

const ViewportProvider = (props: any) => {
  // This is the exact same logic that we previously had in our hook

  const [width, setWidth] = React.useState(
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  const [height, setHeight] = React.useState(
    typeof window !== 'undefined' ? window.innerHeight : 0
  );

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  /* Now we are dealing with a context instead of a Hook, so instead
     of returning the width and height we store the values in the
     value of the Provider */
  return (
    <viewportContext.Provider value={{ width, height }}>
      {props.children}
    </viewportContext.Provider>
  );
};

/* Rewrite the "useViewport" hook to pull the width and height values
   out of the context instead of calculating them itself */
const useViewport = () => {
  /* We can use the "useContext" Hook to acccess a context from within
     another Hook, remember, Hooks are composable! */
  const { width, height } = React.useContext(viewportContext);
  return { width, height };
};

export default ViewportProvider;
export { useViewport };
